import { AxiosResponse } from 'axios';
import { api } from './base/api';
import { ISupplierInventoryHistoryApi } from './base/supplierInventoryHistoryApi';
import { Result } from '../models/common/resultResponse';
import { SupplierInventoryRequest } from '../models/request/supplierInventoryRequest';
import {
  SupplierInventoryGridHistoryResponse,
  SupplierInventoryResponse
} from '../models/response';
import { PaginationResponse } from '../models/common/paginationResponse';

const baseRoute: string = 'SupplierInventoryHistory';

export class SupplierInventoryHistoryApi extends ISupplierInventoryHistoryApi {
  getHistoryInventory(
    request: SupplierInventoryRequest
  ): Promise<
    AxiosResponse<PaginationResponse<SupplierInventoryGridHistoryResponse>>
  > {
    return api.get(`${baseRoute}/getSupplierInvHisGridByGuid`, {
      params: request
    });
  }

  getHistoryDetail(
    request: SupplierInventoryRequest
  ): Promise<AxiosResponse<Result<SupplierInventoryResponse>>> {
    return api.get(`${baseRoute}/GetSupplierInvEditHisDetailByGuid`, {
      params: request
    });
  }

  getImportDetail(
    request: SupplierInventoryRequest
  ): Promise<AxiosResponse<Result<SupplierInventoryResponse>>> {
    return api.get(`${baseRoute}/getSupplierInvImportHisDetailByGuid`, {
      params: request
    });
  }
}

